// This file is generated by scripts/generate-seo-pages.mjs.
// Do not edit by hand.

export type SeoEnhancement = {
  heading: string;
  text: string;
  sections: Array<{
    heading: string;
    text: string;
  }>;
  tasks: string[];
};

export type SeoPage = {
  slug: string;
  appHash: string;
  title: string;
  description: string;
  h1: string;
  lead: string;
  relatedSlugs: string[];
  primaryKeywords: string[];
  steps: string[];
  faqs: Array<[string, string]>;
  enhancement: SeoEnhancement | null;
};

export const seoPages: SeoPage[] = [
  {
    "slug": "merge-pdf",
    "appHash": "merge",
    "title": "Объединить ПДФ онлайн в один файл бесплатно",
    "description": "Объединить ПДФ онлайн: склейте несколько PDF-файлов в один файл, переставьте порядок и скачайте результат прямо в браузере.",
    "h1": "Объединить ПДФ онлайн в один файл",
    "lead": "Склейте несколько PDF или ПДФ-файлов в один документ. Порядок можно изменить перед сохранением, файлы остаются на устройстве.",
    "relatedSlugs": [
      "compress-pdf",
      "organize-pdf",
      "split-pdf"
    ],
    "primaryKeywords": [
      "объединить пдф",
      "объединить pdf",
      "объединить пдф онлайн",
      "объединить пдф онлайн в один файл",
      "соединить пдф файлы в один"
    ],
    "steps": [
      "Добавьте PDF-файлы.",
      "Переставьте их в нужном порядке.",
      "Нажмите «Склеить и скачать»."
    ],
    "faqs": [
      [
        "Можно ли объединить PDF бесплатно?",
        "Да. Инструмент работает бесплатно в браузере и не требует регистрации."
      ],
      [
        "Файлы отправляются на сервер?",
        "Нет. Склейка выполняется локально в текущей вкладке браузера."
      ],
      [
        "Можно ли изменить порядок PDF перед объединением?",
        "Да. Перед сохранением файлы можно перетащить в нужном порядке."
      ]
    ],
    "enhancement": {
      "heading": "Объединить PDF в один файл без лишних шагов",
      "text": "Когда нужно быстро соединить несколько документов, добавьте PDF-файлы, проверьте порядок и сохраните один общий файл. Это удобно для договоров, приложений, сканов, чеков и отчётов.",
      "sections": [
        {
          "heading": "Когда удобно соединить PDF-файлы",
          "text": "Объединение PDF полезно, когда несколько документов нужно отправить одним файлом: договор и приложения, сканы паспорта, акты, счета, чеки или части отчёта. Перед сохранением можно проверить порядок файлов, чтобы итоговый PDF открывался в правильной последовательности."
        },
        {
          "heading": "Что происходит с файлами",
          "text": "Склейка выполняется в браузере. Документы не загружаются на сервер ПДФКА, поэтому инструмент подходит для быстрых рабочих задач и личных документов. Если исходный PDF повреждён, приложение может использовать режим совместимости и предупредит, если текстовый слой не сохранится."
        }
      ],
      "tasks": [
        "Склеить договор, приложения и сканы в один PDF.",
        "Объединить несколько PDF-файлов после сканирования.",
        "Собрать один файл из отчётов, актов, чеков или инструкций."
      ]
    }
  },
  {
    "slug": "pdf-to-word",
    "appHash": "pdf-to-docx",
    "title": "ПДФ в Ворд онлайн — конвертировать PDF в DOCX",
    "description": "ПДФ в Ворд онлайн: конвертируйте PDF в DOCX, извлекайте абзацы, заголовки, жирный и курсив прямо в браузере.",
    "h1": "ПДФ в Ворд онлайн",
    "lead": "Конвертируйте ПДФ в редактируемый Word-файл DOCX: договоры, отчёты, инструкции, письма и другие документы прямо в браузере.",
    "relatedSlugs": [
      "word-to-pdf",
      "pdf-to-text",
      "edit-pdf"
    ],
    "primaryKeywords": [
      "пдф в ворд",
      "pdf to word",
      "конвертировать пдф в ворд",
      "перевести пдф в ворд онлайн бесплатно",
      "из pdf в word"
    ],
    "steps": [
      "Добавьте PDF.",
      "Запустите конвертацию в DOCX.",
      "Скачайте готовый Word-файл."
    ],
    "faqs": [
      [
        "Почему результат может отличаться от исходного PDF?",
        "PDF хранит страницы как готовую разметку, поэтому сложные таблицы и многоколоночные макеты могут переноситься упрощённо."
      ],
      [
        "Работает ли ПДФ в Ворд со сканами?",
        "Если скан уже содержит распознанный текстовый слой, его можно конвертировать в DOCX. Если страница является только изображением, сначала нужен OCR."
      ],
      [
        "Файл остаётся приватным?",
        "Да. Обработка выполняется в браузере, без отправки PDF на сервер."
      ]
    ],
    "enhancement": {
      "heading": "Конвертировать PDF в Word для редактирования",
      "text": "ПДФКА превращает PDF в редактируемый DOCX: файл можно открыть в Word, поправить абзацы, заголовки и базовое форматирование, а затем сохранить или отправить документ дальше.",
      "sections": [
        {
          "heading": "Что сохраняется при переводе в Word",
          "text": "Инструмент извлекает текст, абзацы, заголовки, жирный и курсив, чтобы получить редактируемый DOCX для Word или совместимого редактора. Такой формат удобен для договоров, писем, инструкций, отчётов и документов, которые нужно быстро поправить."
        },
        {
          "heading": "Сканы и сложная верстка",
          "text": "Если PDF является только фотографией страницы, внутри него может не быть текста для извлечения; тогда сначала нужен OCR. Сложные таблицы, много колонок и нестандартная верстка могут переноситься упрощённо, поэтому перед отправкой стоит быстро проверить результат."
        }
      ],
      "tasks": [
        "Преобразовать текстовый PDF в DOCX.",
        "Получить Word-файл из договора, письма или отчёта.",
        "Извлечь абзацы и базовое форматирование из PDF."
      ]
    }
  },
  {
    "slug": "word-to-pdf",
    "appHash": "docx-to-pdf",
    "title": "Ворд в ПДФ онлайн — конвертировать DOCX в PDF",
    "description": "Ворд в ПДФ онлайн: конвертируйте DOCX и Word в PDF для отправки, печати или архива прямо в браузере.",
    "h1": "Ворд в ПДФ онлайн",
    "lead": "Сохраните DOCX как PDF для отправки, печати или архива. Инструмент делает текстовый PDF и работает локально в браузере.",
    "relatedSlugs": [
      "pdf-to-word",
      "merge-pdf",
      "compress-pdf"
    ],
    "primaryKeywords": [
      "ворд в пдф",
      "word to pdf",
      "docx в pdf",
      "конвертировать ворд в пдф",
      "перевести ворд в пдф"
    ],
    "steps": [
      "Добавьте DOCX-файл.",
      "Выберите параметры страницы.",
      "Скачайте PDF."
    ],
    "faqs": [
      [
        "Поддерживается ли старый .doc?",
        "Основной формат инструмента — .docx. Старые .doc лучше предварительно сохранить как DOCX."
      ],
      [
        "Нужен ли Microsoft Word?",
        "Нет. Конвертация запускается в браузере."
      ],
      [
        "Документ куда-то загружается?",
        "Нет. ПДФКА не отправляет файл на сервер."
      ]
    ],
    "enhancement": {
      "heading": "Перевести Word в PDF для отправки и печати",
      "text": "Выберите DOCX-файл и получите PDF-версию для почты, печати, архива или загрузки в форму. Для обычных документов достаточно стандартных настроек.",
      "sections": [
        {
          "heading": "DOCX в PDF без Microsoft Word",
          "text": "Страница подходит для документов Word в формате DOCX: резюме, договоров, инструкций, заявлений и писем. Конвертация запускается прямо в браузере, поэтому не нужно открывать Microsoft Word или устанавливать отдельный PDF-принтер."
        },
        {
          "heading": "Когда лучше сохранить документ как PDF",
          "text": "PDF удобен для отправки, печати и архива: файл выглядит одинаково у получателя и обычно не меняет разметку при открытии. Старые файлы DOC лучше заранее сохранить как DOCX, потому что основной формат этого инструмента именно DOCX в PDF."
        }
      ],
      "tasks": [
        "Сохранить DOCX как PDF для почты.",
        "Подготовить документ Word к печати.",
        "Сделать PDF-версию резюме, договора или инструкции."
      ]
    }
  },
  {
    "slug": "compress-pdf",
    "appHash": "compress",
    "title": "Сжать ПДФ онлайн — уменьшить размер PDF файла",
    "description": "Сжать ПДФ онлайн: уменьшите размер PDF-файла для почты, формы или архива. Проверка размера перед скачиванием.",
    "h1": "Сжать ПДФ онлайн",
    "lead": "Уменьшите размер PDF для почты, мессенджеров, формы загрузки или архива. Лучше всего сжимаются сканы и документы с тяжёлыми изображениями.",
    "relatedSlugs": [
      "merge-pdf",
      "split-pdf",
      "organize-pdf"
    ],
    "primaryKeywords": [
      "сжать пдф",
      "сжать pdf",
      "сжать пдф онлайн",
      "уменьшить размер pdf",
      "сжать пдф онлайн бесплатно"
    ],
    "steps": [
      "Добавьте PDF.",
      "Выберите уровень сжатия.",
      "Скачайте результат, если он действительно стал меньше."
    ],
    "faqs": [
      [
        "Почему иногда PDF становится больше?",
        "Текстовые и векторные PDF уже могут быть хорошо сжаты. В таком случае ПДФКА предупреждает и не скачивает увеличенный файл автоматически."
      ],
      [
        "Текст останется выделяемым?",
        "Текущий JPEG-режим превращает страницы в изображения, поэтому текст в результате не выделяется."
      ],
      [
        "Когда это полезно?",
        "Для сканов, фото-документов и PDF с большим количеством изображений."
      ]
    ],
    "enhancement": {
      "heading": "Сжать PDF и уменьшить размер файла",
      "text": "Сжатие помогает, когда PDF не проходит по лимиту почты, формы или мессенджера. JPEG-режим лучше подходит для сканов и документов с изображениями; если важно сохранить выделяемый текст, проверьте результат перед отправкой.",
      "sections": [
        {
          "heading": "Когда PDF хорошо сжимается",
          "text": "Лучше всего уменьшаются сканы, фото-документы и PDF с тяжёлыми изображениями. Это частая задача перед отправкой файла по email, загрузкой в форму или пересылкой документа, где есть ограничение по размеру."
        },
        {
          "heading": "Почему размер может не уменьшиться",
          "text": "Текстовые и векторные PDF уже могут быть оптимизированы. В JPEG-режиме страницы пересобираются как изображения, поэтому текст перестаёт выделяться. Если новый файл получается больше исходного, ПДФКА предупреждает и не скачивает увеличенный результат автоматически."
        }
      ],
      "tasks": [
        "Уменьшить размер PDF для отправки по email.",
        "Сжать скан паспорта, договора или заявления.",
        "Подготовить тяжелый PDF для загрузки на сайт или в форму."
      ]
    }
  },
  {
    "slug": "split-pdf",
    "appHash": "split",
    "title": "Разделить ПДФ онлайн на страницы — разбить PDF",
    "description": "Разделить ПДФ онлайн: разбейте PDF на страницы или диапазоны и скачайте отдельные PDF-файлы или архив.",
    "h1": "Разделить ПДФ онлайн на страницы",
    "lead": "Разрежьте PDF по страницам или диапазонам: например 1-3, 5, 7-9. Каждый диапазон сохранится отдельным файлом с понятным именем.",
    "relatedSlugs": [
      "organize-pdf",
      "merge-pdf",
      "compress-pdf"
    ],
    "primaryKeywords": [
      "разделить пдф",
      "разделить pdf",
      "разделить пдф онлайн на страницы",
      "разбить пдф на страницы онлайн",
      "извлечь страницы pdf"
    ],
    "steps": [
      "Добавьте PDF.",
      "Введите страницы или диапазоны.",
      "Скачайте отдельные PDF или архивом."
    ],
    "faqs": [
      [
        "Можно ли скачать все части архивом?",
        "Да. Для нескольких результатов есть кнопка «Скачать все архивом»."
      ],
      [
        "Что если PDF повреждён?",
        "Если PDF открывается для просмотра, ПДФКА может сохранить страницы через режим изображений."
      ],
      [
        "Сохраняется ли текстовый слой?",
        "При нативном разделении — да. В fallback-режиме страницы сохраняются как изображения."
      ]
    ],
    "enhancement": {
      "heading": "Разделить PDF на страницы или диапазоны",
      "text": "Укажите страницы или диапазоны и получите отдельные PDF-файлы. Можно вынуть одну часть большого документа, разделить скан по разделам или подготовить несколько файлов для отправки.",
      "sections": [
        {
          "heading": "Разбить PDF на страницы или части",
          "text": "Инструмент подходит, когда большой PDF нужно разделить на отдельные файлы: вынуть приложение из договора, сохранить несколько страниц отчёта или разложить скан по разделам. Диапазоны можно указать через запятую, например 1-3, 5, 7-9."
        },
        {
          "heading": "Разделить или удалить страницы",
          "text": "Если нужно получить несколько отдельных файлов, используйте разделение PDF. Если задача в том, чтобы убрать лишние листы и сохранить один новый документ, удобнее перейти к инструменту организации страниц PDF."
        }
      ],
      "tasks": [
        "Вынуть нужные страницы из большого PDF.",
        "Разбить документ на отдельные части по диапазонам.",
        "Сохранить каждую часть с понятным номером в имени файла."
      ]
    }
  },
  {
    "slug": "edit-pdf",
    "appHash": "edit",
    "title": "Редактор ПДФ онлайн — редактировать PDF бесплатно",
    "description": "Редактор ПДФ онлайн: добавляйте текст, выделения, изображения и аннотации поверх PDF прямо в браузере.",
    "h1": "Редактор ПДФ онлайн",
    "lead": "Добавляйте текст, выделения, изображения и пометки поверх PDF-страниц. Можно быстро поправить документ перед отправкой или печатью.",
    "relatedSlugs": [
      "sign-pdf",
      "organize-pdf",
      "compress-pdf"
    ],
    "primaryKeywords": [
      "редактор пдф",
      "редактировать пдф онлайн бесплатно",
      "редактор пдф онлайн",
      "pdf editor",
      "пдф редактор онлайн"
    ],
    "steps": [
      "Добавьте PDF.",
      "Выберите инструмент редактирования.",
      "Сохраните обновлённый PDF."
    ],
    "faqs": [
      [
        "Можно ли менять существующий текст?",
        "Да. Режим правки текстового слоя позволяет редактировать текст в PDF, а сложные документы лучше проверять перед отправкой."
      ],
      [
        "Можно ли добавить новый текст поверх страницы?",
        "Да. Можно добавить новый текстовый блок, переместить его или удалить."
      ],
      [
        "Файл сохраняется на сервере?",
        "Нет. Редактирование выполняется локально в браузере."
      ]
    ],
    "enhancement": {
      "heading": "Редактировать PDF онлайн: текст, пометки и изображения",
      "text": "Для быстрых правок можно добавить новый текст, выделение, изображение или пометку поверх страницы. Режим правки текстового слоя помогает изменить существующий текст в PDF и сохранить обновлённый документ.",
      "sections": [
        {
          "heading": "Какие правки удобно делать онлайн",
          "text": "Редактор подходит для быстрых визуальных изменений: добавить новый текст, выделить место, поставить изображение, пометку или комментарий поверх страницы. Это полезно, когда нужно быстро подготовить PDF перед отправкой или печатью."
        },
        {
          "heading": "Правка текста и пометок в PDF",
          "text": "PDF не хранит текст так же просто, как Word-документ, поэтому результат зависит от структуры файла. Редактор лучше всего работает с PDF, где есть текстовый слой; сканы и сложная верстка могут требовать ручной проверки перед отправкой."
        }
      ],
      "tasks": [
        "Добавить новый текст поверх страницы PDF.",
        "Поставить выделение, отметку или изображение.",
        "Сохранить PDF после быстрых визуальных правок."
      ]
    }
  },
  {
    "slug": "jpg-to-pdf",
    "appHash": "jpg-to-pdf",
    "title": "Джипег в ПДФ онлайн — фото в ПДФ и JPG в ПДФ",
    "description": "Джипег в ПДФ онлайн: конвертируйте JPG в ПДФ, фото в ПДФ, PNG и ПНГ в один PDF-файл прямо в браузере.",
    "h1": "Джипег в ПДФ онлайн",
    "lead": "Соберите фото в ПДФ или конвертируйте джипег в ПДФ: добавьте JPG, JPEG, PNG или ПНГ, проверьте порядок страниц и скачайте один PDF-файл.",
    "relatedSlugs": [
      "pdf-to-jpg",
      "merge-pdf",
      "compress-pdf"
    ],
    "primaryKeywords": [
      "джипег в пдф",
      "jpg в пдф",
      "фото в пдф",
      "пнг в пдф",
      "jpeg в pdf",
      "png в pdf",
      "конвертировать jpg в pdf"
    ],
    "steps": [
      "Добавьте изображения.",
      "Проверьте порядок страниц.",
      "Скачайте PDF."
    ],
    "faqs": [
      [
        "Можно ли конвертировать джипег в ПДФ?",
        "Да. Добавьте JPG или JPEG-файл, при необходимости добавьте другие фото и скачайте готовый PDF."
      ],
      [
        "Можно ли сделать ПНГ в ПДФ?",
        "Да. PNG-изображения тоже поддерживаются: можно добавить один ПНГ или несколько файлов и сохранить их одним PDF."
      ],
      [
        "Можно ли менять порядок изображений?",
        "Да. Перед созданием PDF изображения можно переставлять."
      ],
      [
        "Изображения отправляются на сервер?",
        "Нет. PDF собирается в браузере."
      ]
    ],
    "enhancement": {
      "heading": "JPG в ПДФ и фото в ПДФ",
      "text": "Добавьте фото, сканы, JPG, JPEG или PNG, расставьте изображения по порядку и сохраните один PDF-файл. Это удобно, когда нужно сделать джипег в ПДФ, фото в ПДФ или пнг в пдф для документов, чеков и заявлений.",
      "sections": [
        {
          "heading": "Джипег в ПДФ для документов и сканов",
          "text": "Страница подходит для фотографий документов, сканов, чеков, заявлений, страниц тетради и любых изображений JPG, JPEG или PNG. Можно конвертировать один джипег в ПДФ или добавить несколько файлов, расположить их в нужном порядке и получить один PDF для отправки или печати."
        },
        {
          "heading": "Как подготовить фото в ПДФ",
          "text": "Перед созданием PDF проверьте порядок страниц и качество фото. Если документ нужно отправить как один файл, добавьте все изображения сразу: JPG в ПДФ, PNG или ПНГ в ПДФ собираются одинаково. Обработка выполняется локально в браузере, поэтому фотографии не отправляются на сервер ПДФКА."
        }
      ],
      "tasks": [
        "Собрать фото документов в один PDF.",
        "Конвертировать JPG, JPEG, джипег или ПНГ в PDF.",
        "Объединить несколько изображений как страницы одного PDF."
      ]
    }
  },
  {
    "slug": "pdf-to-jpg",
    "appHash": "pdf-to-jpg",
    "title": "ПДФ в JPG онлайн — ПДФ в джипег и PDF в фото",
    "description": "ПДФ в JPG онлайн: конвертируйте ПДФ в джипег, PDF в фото, PDF в JPG или PNG и скачивайте страницы файлами или архивом.",
    "h1": "ПДФ в джипег и ПДФ в фото онлайн",
    "lead": "Преобразуйте ПДФ в JPG, ПДФ в джипег или PDF в фото: скачайте страницы как изображения для сайта, презентации, мессенджера или предпросмотра.",
    "relatedSlugs": [
      "jpg-to-pdf",
      "compress-pdf",
      "edit-pdf"
    ],
    "primaryKeywords": [
      "пдф в jpg",
      "пдф в джипег",
      "pdf в фото",
      "pdf в jpg",
      "pdf to jpg",
      "конвертировать пдф в jpg",
      "из пдф в jpg"
    ],
    "steps": [
      "Добавьте PDF.",
      "Выберите формат и масштаб.",
      "Скачайте страницы отдельно или архивом."
    ],
    "faqs": [
      [
        "Можно ли сделать ПДФ в джипег?",
        "Да. Добавьте PDF-файл, выберите JPG и скачайте страницы как JPEG-изображения или одним архивом."
      ],
      [
        "Можно ли конвертировать PDF в фото?",
        "Да. Инструмент сохраняет страницы PDF в фото: JPG или PNG изображения, которые удобно отправить или вставить в презентацию."
      ],
      [
        "Можно ли скачать все страницы сразу?",
        "Да. Для многостраничного PDF есть скачивание архивом."
      ],
      [
        "Поддерживается PNG?",
        "Да. Можно выбрать JPG или PNG."
      ],
      [
        "Сохраняется ли текст?",
        "Изображение не содержит выделяемого текстового слоя."
      ]
    ],
    "enhancement": {
      "heading": "ПДФ в джипег, JPG или фото",
      "text": "Сохраните страницы PDF как изображения для сайта, презентации, предпросмотра или пересылки. Если нужен ПДФ в джипег или PDF в фото, выберите JPG: многостраничный документ можно скачать отдельными файлами или одним архивом.",
      "sections": [
        {
          "heading": "Когда нужен PDF в JPG",
          "text": "Конвертация из ПДФ в JPG полезна для превью, презентаций, публикации страницы на сайте, пересылки в мессенджере или сохранения отдельных страниц как картинок. Многостраничный PDF можно скачать отдельными изображениями или архивом."
        },
        {
          "heading": "ПДФ в JPG или PNG",
          "text": "JPG обычно подходит для фотографий и документов, где важен небольшой размер файла. PNG лучше сохраняет чёткие линии, схемы и интерфейсы. В обоих случаях результат становится изображением, поэтому текст внутри картинки не будет выделяться как текст."
        }
      ],
      "tasks": [
        "Сохранить одну или все страницы PDF как JPG.",
        "Конвертировать ПДФ в джипег для пересылки или публикации.",
        "Сделать PDF в фото для презентации, сайта или мессенджера.",
        "Получить изображения для превью, сайта или презентации.",
        "Скачать много страниц одним архивом."
      ]
    }
  },
  {
    "slug": "sign-pdf",
    "appHash": "sign",
    "title": "Подписать ПДФ онлайн — подпись, дата и текст",
    "description": "Подписать ПДФ онлайн: добавьте визуальную подпись, текст, дату или галочку поверх документа прямо в браузере.",
    "h1": "Подписать ПДФ онлайн",
    "lead": "Добавьте визуальную подпись, дату, текст или галочку на нужную страницу PDF и сохраните готовый документ.",
    "relatedSlugs": [
      "edit-pdf",
      "organize-pdf",
      "merge-pdf"
    ],
    "primaryKeywords": [
      "подписать пдф",
      "подписать pdf онлайн",
      "подписать пдф онлайн",
      "подпись pdf",
      "добавить подпись в pdf"
    ],
    "steps": [
      "Добавьте PDF.",
      "Поставьте подпись или текст на страницу.",
      "Скачайте подписанный PDF."
    ],
    "faqs": [
      [
        "Это электронная цифровая подпись?",
        "Нет. Инструмент добавляет визуальную подпись или текст поверх PDF. Криптографическая ЭЦП не создаётся."
      ],
      [
        "Можно ли удалить добавленный элемент?",
        "Да. Выберите добавленный объект и удалите его до сохранения."
      ],
      [
        "Файл остаётся на устройстве?",
        "Да. Подпись добавляется в браузере."
      ]
    ],
    "enhancement": {
      "heading": "Подписать PDF визуальной подписью",
      "text": "Поставьте визуальную подпись, дату, галочку или текст в нужном месте документа. Это подходит для простого заполнения и согласования, но не заменяет криптографическую электронную подпись.",
      "sections": [
        {
          "heading": "Добавить подпись в PDF",
          "text": "Инструмент позволяет поставить визуальную подпись, дату, текст или галочку поверх нужной страницы. Это удобно для согласования, заполнения простых форм и подготовки документа к отправке, когда нужна именно видимая отметка на PDF."
        },
        {
          "heading": "Это не ЭЦП",
          "text": "ПДФКА не создаёт криптографическую электронную подпись и не заменяет сервисы ЭДО. Если нужен юридически значимый сертификат или подпись ЭЦП, используйте специализированный сервис. Здесь добавляется только визуальный слой поверх документа."
        }
      ],
      "tasks": [
        "Поставить визуальную подпись на PDF.",
        "Добавить дату, текст или галочку на страницу.",
        "Сохранить подписанный файл без загрузки документа на сервер."
      ]
    }
  },
  {
    "slug": "rotate-pdf",
    "appHash": "rotate",
    "title": "Повернуть ПДФ онлайн — перевернуть страницы PDF",
    "description": "Повернуть ПДФ онлайн: разверните одну страницу или весь PDF на 90, 180 или 270 градусов и скачайте файл.",
    "h1": "Повернуть ПДФ онлайн",
    "lead": "Исправьте ориентацию страниц PDF: поверните одну страницу, несколько страниц или весь документ.",
    "relatedSlugs": [
      "organize-pdf",
      "split-pdf",
      "compress-pdf"
    ],
    "primaryKeywords": [
      "повернуть пдф",
      "повернуть пдф онлайн",
      "перевернуть pdf",
      "перевернуть пдф онлайн",
      "rotate pdf"
    ],
    "steps": [
      "Добавьте PDF.",
      "Выберите поворот страниц.",
      "Сохраните PDF."
    ],
    "faqs": [
      [
        "Можно ли повернуть только одну страницу?",
        "Да. Поворот применяется к выбранным страницам."
      ],
      [
        "Можно ли повернуть весь документ сразу?",
        "Да. Есть быстрые действия для всех страниц."
      ],
      [
        "Нужно ли загружать файл на сервер?",
        "Нет. Поворот выполняется локально."
      ]
    ],
    "enhancement": {
      "heading": "Повернуть страницы PDF онлайн",
      "text": "Исправьте ориентацию после сканирования: поверните одну страницу, несколько выбранных страниц или весь документ перед отправкой.",
      "sections": [
        {
          "heading": "Повернуть или перевернуть PDF",
          "text": "Поворот нужен после сканирования, когда часть страниц оказалась боком или вверх ногами. Можно развернуть одну страницу, несколько выбранных страниц или весь документ на 90, 180 или 270 градусов."
        },
        {
          "heading": "Сохранить ориентацию страниц",
          "text": "После поворота создаётся новый PDF с исправленной ориентацией. Это удобнее, чем просить получателя вручную поворачивать страницы при каждом открытии файла. Обработка выполняется локально в браузере."
        }
      ],
      "tasks": [
        "Повернуть одну страницу PDF.",
        "Исправить ориентацию всех страниц документа.",
        "Сохранить PDF после поворота без пересборки вручную."
      ]
    }
  },
  {
    "slug": "pdf-to-text",
    "appHash": "pdf-to-txt",
    "title": "ПДФ в текст онлайн — извлечь текст из PDF",
    "description": "ПДФ в текст онлайн: извлеките текстовый слой из PDF, скопируйте результат или скачайте TXT прямо в браузере.",
    "h1": "ПДФ в текст онлайн",
    "lead": "Получите обычный текст из PDF, если в документе уже есть текстовый слой. Результат можно скопировать или скачать как TXT.",
    "relatedSlugs": [
      "pdf-to-word",
      "edit-pdf",
      "split-pdf"
    ],
    "primaryKeywords": [
      "пдф в текст",
      "pdf to text",
      "извлечь текст из pdf",
      "извлечь текст из пдф",
      "pdf в txt"
    ],
    "steps": [
      "Добавьте PDF.",
      "Нажмите «Извлечь текст».",
      "Скопируйте результат или скачайте TXT."
    ],
    "faqs": [
      [
        "Почему текст не найден?",
        "Скорее всего PDF состоит из изображений или не содержит встроенного текстового слоя. Такой файл не даст текст в этом инструменте."
      ],
      [
        "Можно ли скачать результат?",
        "Да. Извлечённый текст можно скачать как .txt."
      ],
      [
        "PDF отправляется на сервер?",
        "Нет. Извлечение идёт в браузере."
      ]
    ],
    "enhancement": {
      "heading": "Извлечь текст из PDF",
      "text": "Если в PDF есть текстовый слой, его можно извлечь в обычный TXT и скопировать. Если страница является изображением, встроенного текста в файле может не быть.",
      "sections": [
        {
          "heading": "PDF в TXT и обычный текст",
          "text": "Инструмент извлекает текстовый слой из PDF и показывает результат как обычный текст. Его можно скопировать или скачать TXT-файлом для заметок, поиска, проверки договора, цитирования или переноса текста в другой редактор."
        },
        {
          "heading": "Почему текст может не найден",
          "text": "Если PDF сделан из скана или фотографии, внутри файла может не быть текстового слоя. В этом случае нужен OCR. ПДФКА честно показывает, когда текст не найден, чтобы не обещать распознавание там, где его нет."
        }
      ],
      "tasks": [
        "Получить обычный текст из PDF-документа.",
        "Скопировать содержимое текстового PDF.",
        "Понять, есть ли в PDF выделяемый текст."
      ]
    }
  },
  {
    "slug": "organize-pdf",
    "appHash": "organize",
    "title": "Удалить страницы из ПДФ онлайн — порядок PDF",
    "description": "Удалите страницы из ПДФ онлайн: поменяйте порядок, поверните или извлеките нужные листы прямо в браузере.",
    "h1": "Удалить страницы из ПДФ онлайн",
    "lead": "Управляйте страницами PDF: меняйте порядок, удаляйте лишнее, поворачивайте листы и сохраняйте новый файл.",
    "relatedSlugs": [
      "split-pdf",
      "rotate-pdf",
      "merge-pdf"
    ],
    "primaryKeywords": [
      "организовать пдф",
      "удалить страницы из pdf онлайн",
      "удалить страницы пдф",
      "страницы pdf",
      "извлечь страницы pdf"
    ],
    "steps": [
      "Добавьте PDF.",
      "Перетащите, поверните или удалите страницы.",
      "Сохраните новый PDF."
    ],
    "faqs": [
      [
        "Можно ли удалить страницы из PDF?",
        "Да. Удалите ненужные страницы и сохраните новый документ."
      ],
      [
        "Можно ли извлечь выбранные страницы?",
        "Да. Выделите страницы и скачайте только их."
      ],
      [
        "Что с повреждёнными PDF?",
        "Если PDF можно отрендерить, ПДФКА открывает его в режиме совместимости."
      ]
    ],
    "enhancement": {
      "heading": "Организовать страницы PDF",
      "text": "Работайте со страницами внутри одного PDF: удаляйте лишние листы, меняйте порядок, поворачивайте страницы и сохраняйте новый документ.",
      "sections": [
        {
          "heading": "Удалить страницы из PDF",
          "text": "Если в документе есть лишние листы, их можно удалить и сохранить новый PDF. Это удобно для сканов, договоров, анкет и отчётов, где нужно убрать пустые страницы, дубликаты или служебные листы перед отправкой."
        },
        {
          "heading": "Поменять порядок и извлечь страницы",
          "text": "Страницы можно переставлять перетаскиванием, поворачивать и выбирать для нового файла. Если нужно не просто удалить лишнее, а получить отдельные части большого документа, используйте также инструмент разделения PDF."
        }
      ],
      "tasks": [
        "Удалить лишние страницы из PDF.",
        "Поменять порядок страниц перетаскиванием.",
        "Собрать новый PDF из выбранных страниц."
      ]
    }
  },
  {
    "slug": "excel-to-pdf",
    "appHash": "xlsx-to-pdf",
    "title": "Эксель в ПДФ онлайн — конвертировать XLSX в PDF",
    "description": "Эксель в ПДФ онлайн: конвертируйте XLSX и Excel в PDF с таблицами, листами и ориентацией страницы.",
    "h1": "Эксель в ПДФ онлайн",
    "lead": "Преобразуйте XLSX-таблицу в PDF для отчёта, печати или отправки.",
    "relatedSlugs": [
      "csv-to-pdf",
      "merge-pdf",
      "compress-pdf"
    ],
    "primaryKeywords": [
      "эксель в пдф",
      "excel в pdf",
      "xlsx в pdf",
      "из эксель в пдф",
      "конвертировать эксель в пдф"
    ],
    "steps": [
      "Добавьте XLSX.",
      "Выберите лист и ориентацию.",
      "Скачайте PDF."
    ],
    "faqs": [
      [
        "Поддерживается ли XLS?",
        "Основной формат инструмента — XLSX. Старые XLS лучше сохранить как XLSX."
      ],
      [
        "Можно выбрать лист?",
        "Да. Перед созданием PDF можно выбрать лист таблицы."
      ],
      [
        "Таблица загружается на сервер?",
        "Нет. Конвертация выполняется в браузере."
      ]
    ],
    "enhancement": {
      "heading": "Excel в PDF для таблиц и отчетов",
      "text": "Сохраните XLSX-таблицу в PDF для печати, отчёта, прайс-листа или отправки. Можно выбрать лист, ориентацию страницы и сохранить читаемую PDF-версию таблицы.",
      "sections": [
        {
          "heading": "XLSX и Excel в PDF",
          "text": "Инструмент подходит для XLSX-таблиц: отчётов, прайс-листов, списков, выгрузок и небольших рабочих таблиц. Перед сохранением можно выбрать лист и ориентацию страницы, чтобы PDF было удобно читать или печатать."
        },
        {
          "heading": "Что проверить перед отправкой",
          "text": "Таблицы бывают широкими, поэтому перед скачиванием стоит проверить ориентацию и читаемость колонок. Старые XLS лучше предварительно сохранить как XLSX. Конвертация выполняется локально, без отправки таблицы на сервер."
        }
      ],
      "tasks": [
        "Конвертировать XLSX-таблицу в PDF.",
        "Подготовить таблицу Excel к печати.",
        "Сохранить отчет или прайс-лист в PDF."
      ]
    }
  },
  {
    "slug": "csv-to-pdf",
    "appHash": "csv-to-pdf",
    "title": "CSV в ПДФ онлайн — таблицу CSV/TSV в PDF",
    "description": "CSV в ПДФ онлайн: превратите CSV или TSV таблицу в аккуратный PDF-отчёт с кодировкой и разделителем.",
    "h1": "CSV в ПДФ онлайн",
    "lead": "Соберите CSV или TSV в PDF-отчёт с таблицей. Можно выбрать кодировку, разделитель и формат страницы.",
    "relatedSlugs": [
      "excel-to-pdf",
      "merge-pdf",
      "compress-pdf"
    ],
    "primaryKeywords": [
      "csv в pdf",
      "таблицу в pdf",
      "конвертировать csv в pdf"
    ],
    "steps": [
      "Добавьте CSV.",
      "Проверьте кодировку и разделитель.",
      "Скачайте PDF."
    ],
    "faqs": [
      [
        "Поддерживается кириллица?",
        "Да. Можно выбрать кодировку, чтобы корректно открыть русскоязычный CSV."
      ],
      [
        "Можно менять ориентацию страницы?",
        "Да. Есть книжная и альбомная ориентация."
      ],
      [
        "CSV отправляется на сервер?",
        "Нет. Всё выполняется локально."
      ]
    ],
    "enhancement": {
      "heading": "CSV в PDF как аккуратный табличный отчет",
      "text": "Соберите CSV или TSV в PDF-отчёт: выберите кодировку, разделитель, ориентацию страницы и получите таблицу, которую удобно отправить или распечатать.",
      "sections": [
        {
          "heading": "CSV-таблицу в PDF",
          "text": "CSV и TSV часто приходят из CRM, интернет-магазинов, бухгалтерских систем и таблиц. ПДФКА помогает быстро превратить такую выгрузку в читаемый PDF-отчёт для отправки, печати или архивирования."
        },
        {
          "heading": "Кодировка и разделитель",
          "text": "Если в CSV есть кириллица, важно правильно выбрать кодировку. Также можно проверить разделитель: запятая, точка с запятой или табуляция. Всё выполняется в браузере, поэтому табличная выгрузка не отправляется на сервер."
        }
      ],
      "tasks": [
        "Сделать PDF-отчет из CSV или TSV.",
        "Открыть русскоязычную CSV-таблицу с правильной кодировкой.",
        "Сохранить табличную выгрузку в PDF для отправки."
      ]
    }
  }
];
